<template>
	<div class="c-programmation__grid__item">
		<div class="o-show-card-list">
			<div class="o-show-card-list__link">
				<div class="o-show-card-list__link__inner">
					<div class="o-show-card-list__img">
						<span class="o-responsive-img" style="padding-top:95.779220779221%">
							<img :src="date.image" :alt="date.title" />
						</span>
					</div>
					<div class="o-show-card-list__content">
						<div class="o-show-card-list__content__inner">
							<div class="o-show-card-list__content__top">
								<div v-if="date.categories.length > 0" class="o-show-category">
									<span class="o-show-category__color" :class="'u-bg-color-' + couleur"></span>
									<span class="o-show-category__label">{{ date.categories[0].name }}</span>
								</div>
								<div v-if="date.labels.length > 0" class="">
									<div class="o-show-card__tag"
										:class="' u-bg-color-' + couleur">
                                        {{ date.labels[0].name }}
                                    </div>
                                    
								</div>
							</div>
							<h2 class="o-show-card-list__title o-title-3" v-html="date.artiste">
							</h2>
							<div class="o-show-card-list__description" v-html="date.evenement">
							</div>
						</div>
						<div class="o-show-card-list__content__bottom">
							<div class="o-show-card-list__date">
								<Svg id="calendar" />
								<span class="o-show-card-list__date__label">{{ dayMonth }}</span>
							</div>
							<div class="o-show-card-list__time">
								<Svg id="clock" />
								<span class="o-show-card-list__time__label">{{ heure }}</span>
							</div>
							<div class="o-show-card-list__location">
								<Svg id="pin" />
								<span class="o-show-card-list__location__label" v-html="date.lieu_name"></span>
							</div>
						</div>
					</div>
				</div>
				<a :href="date.url" :aria-label="'Plus de détails sur ' + date.artiste + ' - ' + date.evenement">
					<span class="sr-only">{{ date.artiste }} - {{ date.evenement }}</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import Svg from '@/js/components/Svg.vue';

const props = defineProps(['date']);
const dayMonth = ref(
	props.date.date.split('-')[2]
		? props.date.date.split('-')[2] + ' ' + new Date(props.date.date + 'T00:00:00').toLocaleString('fr-CA', {
			month: 'short',
		})
		: ''
);
const heure = ref(
	props.date.heure.split(':')[0] + ' H ' + props.date.heure.split(':')[1]);
const couleur = ref(props.date.categories.length > 0 ? props.date.categories[0].couleur : 1);
let libelle_image = '';
let libelle_alt = '';
props.date.labels.forEach((label) => {
	if (label.image) {
		libelle_image = label.image;
		libelle_alt = label.name;
	}
});
</script>
